import styled from 'styled-components';
import typography from '../../../../theme/typography';
import {StyledDropdownListContainer, StyledDropdownHeader} from '../../../Dropdowns/List/styles';

export const StyledShipsFromContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${StyledDropdownHeader} {
    height: 26px;
    padding-right: 0;
  }

  ${StyledDropdownListContainer} {
    max-width: 385px;
  }
`;

export const StyledShipsFromLabelContainer = styled.div`
  display: flex;
  flex-direction: column;

  h4 {
    ${typography.Subtitle1}
  }

  p {
    ${typography.Body3}
  }
`;
